module.exports = __webpack_public_path__ + "static/media/loader2.bfe097f4.gif";